module.exports = __webpack_public_path__ + "static/media/theater_banner.dbbce589.webp";